import React, { useState, useRef, useEffect } from "react";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Divider,
  Card,
  CardActionArea,
  CardContent,
  Chip,
  Button,
  IconButton,
  TextField,
} from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import FormatListBulletedIcon from "@mui/icons-material/FormatListBulleted";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import LoginModal from "../common/LoginModal";
import CallIcon from "@mui/icons-material/Call";
import SecondaryButton from "../common/SecondaryButton";
import GradientButton from "../common/GradiantButton";
import Dialog from "@mui/material/Dialog";
import CloseIcon from "@mui/icons-material/Close";
import { useNavigate } from "react-router-dom";
import EnquiryModal from "../CustomerInteractions/EnquiryModal";
import ContactModal from "../contact/ContactModal";
import { useTheme, useMediaQuery } from "@mui/material";
import ShareOutlinedIcon from "@mui/icons-material/ShareOutlined";
import FavoriteIcon from "@mui/icons-material/Favorite";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import { useSelector } from "react-redux";
import { Snackbar, Alert } from "@mui/material";



const AprtmentPlotsDetails = ({ data, isAuthenticated }) => {
  const flats = data?.flats || [];
  // console.log(data);
  // debugger
  const [selectedFlat, setSelectedFlat] = useState(
    flats.find(f => f.Status?.toLowerCase() === "available") || flats[0] || null
  );
  const userId = useSelector((state) => state.user.userId);
  const [showSearch, setShowSearch] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentImg, setCurrentImg] = useState(0);
  const [openImageModal, setOpenImageModal] = useState(false);

  const [showContactModal, setShowContactModal] = useState(false);
  const [openEnquiryModal, setOpenEnquiryModal] = useState(false);
  const [showLoginModal, setShowLoginModal] = useState(false);

  const [selectedProperty, setSelectedProperty] = useState(null);
  const [showPopup, setShowPopup] = useState(false);


  const navigate = useNavigate();

  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));     // <600
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md")); // 600–900
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));     // ≥900

  let columnsPerRow = 3; // desktop default

  if (isTablet) {
    columnsPerRow = 2;
  } else if (isMobile) {
    columnsPerRow = 2;
  }

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });

  const scrollRef = useRef(null);

  const [likedItems, setLikedItems] = useState([]);

  const toggleLike = (property) => {
    setLikedItems((prev) =>
      prev.some((p) => p.id === property.id)
        ? prev.filter((p) => p.id !== property.id)
        : [...prev, property]
    );
  };

  const isLiked = (property) => {
    return likedItems.some((p) => p.id === property.id);
  };


  useEffect(() => {
    if (!flats.length) return;

    const firstAvailable =
      flats.find(f => f.Status?.toLowerCase() === "available") || flats[0];

    setSelectedFlat(firstAvailable);
  }, [flats]);


  // 🔐 Login guard (same as ProjectPlotStructure)
  const requireLogin = (callback) => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
      return;
    }
    callback();
  };

  // 🔍 Filter flats
  const filteredFlats = flats.filter((flat) =>
    flat.FlatName?.toLowerCase().includes(searchTerm)
  );
  const formatIndianPrice = (price) => {
    if (!price) return "-";

    const num = Number(price);

    if (num >= 10000000) {
      return `₹${(num / 10000000).toFixed(2)} Cr`;
    }
    if (num >= 100000) {
      return `₹${(num / 100000).toFixed(2)} L`;
    }
    if (num >= 1000) {
      return `₹${(num / 1000).toFixed(1)} K`;
    }
    return `₹${num}`;
  };

  const images =
    selectedFlat?.Images?.length
      ? selectedFlat.Images
      : ["https://images.pexels.com/photos/439391/pexels-photo-439391.jpeg"];


  const checkLogin = (callback) => {
    if (!isAuthenticated) {
      setShowLoginModal(true);
      return;
    }
    callback();
  };
  const getFlatPrice = (flat) =>
    flat.PriceType === "PerSqFt"
      ? flat.SizeInSqFt * flat.Price
      : flat.Price;

  // console.log(filteredFlats);
  // debugger
  const statusPriority = {
    approved: 1,
    pending: 2,
    "in progress": 3,
    rejected: 4,
    sold: 5,
  };

  // console.log(selectedFlat);
  // debugger

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: { xs: "column", md: "row" },
          gap: 2,
        }}
      >
        {/* ================= LEFT SIDE – FLATS LIST ================= */}
        <Box
          sx={{
            width: { xs: "100%", md: "40%" },
            position: "relative",
            display: "flex",

          }}
        >
          <Paper
            ref={scrollRef}
            elevation={3}
            sx={{
              height: 480,
              overflowY: "auto",
              position: "relative",
              minWidth: { xs: "100%", md: "100%" },
            }}
          >
            {/* HEADER */}
            <Box
              sx={{
                width: "100%",
                position: "sticky",
                top: 0,
                zIndex: 1,
                backgroundColor: "#fff",
                p: 1,
                borderBottom: "1px solid #e0e0e0",
              }}
            >
              {!showSearch ? (
                <Box display="flex" justifyContent="space-between">
                  <Box display="flex" alignItems="center" gap={1}>
                    <FormatListBulletedIcon />
                    <Typography fontWeight="bold">
                      Flats ({filteredFlats.length})
                    </Typography>
                  </Box>
                  <IconButton onClick={() => setShowSearch(true)}>
                    <SearchIcon />
                  </IconButton>
                </Box>
              ) : (
                <Box display="flex" gap={1}>
                  <IconButton onClick={() => setShowSearch(false)}>
                    <SearchIcon />
                  </IconButton>
                  <TextField
                    size="small"
                    fullWidth
                    placeholder="Search Flat..."
                    onChange={(e) =>
                      setSearchTerm(e.target.value.toLowerCase())
                    }
                  />
                </Box>
              )}
            </Box>

            {/* FLATS */}
            <Box
              p={3}
              sx={{
                display: "flex",
                flexWrap: "wrap",
                gap: 2,
              }}
            >

              {[...filteredFlats]
                .sort((a, b) => {
                  const statusA = a.Status?.toLowerCase();
                  const statusB = b.Status?.toLowerCase();

                  return (
                    (statusPriority[statusA] || 99) -
                    (statusPriority[statusB] || 99)
                  );
                })
                .map((flat) => {

                  const statusKey = flat.Status?.toLowerCase();
                  const isApproved = statusKey === "approved";
                  const isPending = statusKey === "pending";
                  const isInProgress = statusKey === "in progress";
                  const isSold = statusKey === "sold";
                  const isRejected = statusKey === "rejected";

                  const isSelected = selectedFlat?.Id === flat.Id;

                  return (
                    <Card
                      key={flat.Id}
                      sx={{
                        flex: `0 0 calc(${100 / columnsPerRow}% - 16px)`,
                        maxWidth: `calc(${100 / columnsPerRow}% - 16px)`,
                        padding: 1.5,

                        border: isSelected
                          ? "2px solid #1c272c"
                          : isApproved
                            ? "2px solid #2e7d32"
                            : isPending
                              ? "2px solid #ed6c02"
                              : isInProgress
                                ? "2px solid #0288d1"
                                : isSold
                                  ? "2px solid #616161"
                                  : isRejected
                                    ? "2px solid #d32f2f"
                                    : "2px solid #161515",

                        backgroundColor: isSelected
                          ? "#B3E5FC"
                          : isApproved
                            ? "#D0F0C0"
                            : isPending
                              ? "#FFF3CD"
                              : isInProgress
                                ? "#E3F2FD"
                                : isSold
                                  ? "#E0E0E0"
                                  : isRejected
                                    ? "#FFCDD2"
                                    : "#FFFFFF",

                        cursor: isApproved ? "pointer" : "not-allowed",

                        transition: "all 0.2s ease",

                        "&:hover": {
                          transform: isApproved ? "scale(1.05)" : "none",
                          boxShadow: isApproved
                            ? "0 4px 12px rgba(0,0,0,0.2)"
                            : "none",
                        },

                        textAlign: "center",
                      }}
                      onClick={() => {
                        if (isPending) {
                          setSnackbar({
                            open: true,
                            message:
                              "Admin approval pending. You can view only after approval.",
                            severity: "info",
                          });
                          return;
                        }

                        if (!isApproved) return;

                        setSelectedFlat(flat);
                        setCurrentImg(0);
                      }}
                    >
                      <Typography fontWeight="bold">
                        {flat.FlatName}
                      </Typography>

                      <Typography fontSize={13} mt={1}>
                        Floor: {flat.FloorNo}
                      </Typography>

                      <Typography fontSize={14} fontWeight={600}>
                        {formatIndianPrice(getFlatPrice(flat))}
                      </Typography>

                      <Typography
                        fontSize={12}
                        fontWeight={600}
                        mt={1}
                        sx={{
                          color: isApproved
                            ? "#2e7d32"
                            : isPending
                              ? "#ed6c02"
                              : isInProgress
                                ? "#0288d1"
                                : isSold
                                  ? "#616161"
                                  : isRejected
                                    ? "#d32f2f"
                                    : "#000",
                        }}
                      >
                        {flat.Status}
                      </Typography>
                    </Card>
                  );
                })}



              {!filteredFlats.length && (
                <Typography align="center" color="text.secondary">
                  No flats found
                </Typography>
              )}
            </Box>
          </Paper>
          <Box sx={{ marginLeft: "10px", flexDirection: "column", justifyContent: "flex-end" }}>
            {/* <Box>
             
              <IconButton
                sx={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: 2,
                  borderRadius: 2,

                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isAuthenticated) {
                    setShowLoginModal(true);
                    return;
                  }
                  setSelectedProperty(data);
                  setShowPopup(true);
                }}
                title="Share Project"
              >
                <ShareOutlinedIcon style={{ fontSize: 18, color: theme.normal_icon }} />
              </IconButton>

              <br />

             
              <IconButton
                sx={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: 2,
                  borderRadius: 2,
                  marginTop: 2,

                }}
                onClick={(e) => {
                  e.stopPropagation();
                  if (!isAuthenticated) {
                    setShowLoginModal(true);
                    return;
                  }
                  toggleLike(data);
                }}
                title="Like"
              >
                {isLiked(data) ? (
                  <FavoriteIcon style={{ fontSize: 20, color: "red" }} />
                ) : (
                  <FavoriteBorderIcon style={{ fontSize: 20, color: theme.normal_icon }} />
                )}
              </IconButton>
            </Box> */}

            {/* <Box sx={{
              position: "absolute",
              bottom: "5%",
            }}>
              <IconButton
                sx={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: 2,
                  borderRadius: 2,

                }}
                onClick={() =>
                  scrollRef.current.scrollBy({
                    top: -scrollRef.current.clientHeight,
                    behavior: "smooth",
                  })
                }
              >
                <KeyboardArrowUpIcon sx={{ color: theme.normal_icon }} />
              </IconButton>

              <IconButton
                sx={{
                  backgroundColor: "#F5F5F5",
                  boxShadow: 2,
                  borderRadius: 2,
                  mt: 1,

                }}
                onClick={() =>
                  scrollRef.current.scrollBy({
                    top: scrollRef.current.clientHeight,
                    behavior: "smooth",
                  })
                }
              >
                <KeyboardArrowDownIcon />
              </IconButton>


            </Box> */}
          </Box>


        </Box>

        {/* ================= RIGHT SIDE – FLAT DETAILS ================= */}
        <Box sx={{ width: { xs: "100%", md: "60%" } }}>
          {selectedFlat && (
            <Paper elevation={3} sx={{ p: 2 }}>
              {/* IMAGE */}
              {/* IMAGE CAROUSEL */}
              <Box sx={{ position: "relative", mb: 2 }}>
                <Box
                  component="img"
                  src={images?.length ? images[currentImg] : "https://img.freepik.com/vector-premium/vector-icono-imagen-predeterminado-pagina-imagen-faltante-diseno-sitio-web-o-aplicacion-movil-no-hay-foto-disponible_87543-11093.jpg"}

                  onClick={() => setOpenImageModal(true)}
                  sx={{
                    width: "100%",
                    height: 230,
                    objectFit: "cover",
                    borderRadius: 2,
                    cursor: "pointer",
                  }}
                />

                {/* LEFT ARROW */}
                {images.length > 1 && (
                  <IconButton
                    onClick={() =>
                      setCurrentImg((prev) =>
                        prev === 0 ? images.length - 1 : prev - 1
                      )
                    }
                    sx={{
                      position: "absolute",
                      top: "50%",
                      left: 10,
                      transform: "translateY(-50%)",
                      bgcolor: "white",
                      boxShadow: 2,
                      "&:hover": {
                        bgcolor: "#e9eaeb",      // hover background
                      },
                    }}
                  >
                    <KeyboardArrowUpIcon sx={{ transform: "rotate(-90deg)" }} />
                  </IconButton>
                )}

                {/* RIGHT ARROW */}
                {images.length > 1 && (
                  <IconButton
                    onClick={() =>
                      setCurrentImg((prev) =>
                        prev === images.length - 1 ? 0 : prev + 1
                      )
                    }
                    sx={{
                      position: "absolute",
                      top: "50%",
                      right: 10,
                      transform: "translateY(-50%)",
                      bgcolor: "white",
                      boxShadow: 2,
                      "&:hover": {
                        bgcolor: "#e9eaeb",      // hover background
                      },
                    }}
                  >
                    <KeyboardArrowDownIcon sx={{ transform: "rotate(-90deg)" }} />
                  </IconButton>
                )}
              </Box>


              <Typography variant="h5">
                {selectedFlat.FlatName}

              </Typography>

              <Divider sx={{ my: 2 }} />

             <Grid container spacing={1}>
  {[
    { label: "Type", value: selectedFlat?.FlatType },
    { label: "Facing", value: selectedFlat?.Facing },
    { label: "Floor", value: selectedFlat?.FloorNo },
    {
      label: "Size",
      value: selectedFlat?.SizeInSqFt
        ? `${selectedFlat.SizeInSqFt} SqFt`
        : "-",
    },
    {
      label: "Price",
      value: selectedFlat?.Price
        ? `${formatIndianPrice(selectedFlat.Price)}${
            selectedFlat?.PriceType
              ? ` / ${selectedFlat.PriceType}`
              : ""
          }`
        : "-",
    },
  ].map((item, index) => (
    <Grid key={index}>
      <Box
        sx={{
          minWidth: 110,
          height: 55,
          px: 1.5,
          py: 0.8,
          border: "1px solid #ccc",
          borderRadius: 2,
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Typography
          fontSize={15}
          color="text.secondary"
          lineHeight={1.2}
        >
          {item.label}
        </Typography>

        <Typography
          fontSize={17}
          fontWeight={600}
          lineHeight={1.3}
        >
          {item.value || "-"}
        </Typography>
      </Box>
    </Grid>
  ))}
</Grid>


              <Box
                sx={{
                  display: "flex",
                  flexWrap: "wrap",
                  gap: 2,
                  // justifyContent: "space-between",
                  mt: 3,
                }}
              >
                {/* Site Visit */}
                {isAuthenticated && (
                  <SecondaryButton
                    text="Site Visit"
                    width={{ xs: "47%", sm: "47%", lg: "20%" }}
                    onClick={() => {
                      checkLogin(() => {
                        navigate("/schedulesitevisit", {
                          state: { data: data, flatData: selectedFlat, selectedFlatId: selectedFlat.Id  }
                        });
                      });
                    }}
                  />
                )}



                {/* Enquiry */}
                <SecondaryButton
                  text="Enquiry"
                  width={{ xs: "47%", sm: "47%", lg: "20%" }}
                  onClick={() => {
                    checkLogin(() => setOpenEnquiryModal(true));
                  }}

                />


                {/* Contact */}
                <SecondaryButton
                  text={
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <CallIcon sx={{ mr: 1, fontSize: 22 }} />
                      Contact
                    </Box>
                  }
                  width={{ xs: "47%", sm: "47%", lg: "23%" }}
                  onClick={() => {
                    checkLogin(() => setShowContactModal(true));
                  }}

                  style={{
                    "& svg": { color: "primary.main" },
                    "&:hover svg": { color: "white" },
                  }}
                />

              </Box>

            </Paper>
          )}
        </Box>
      </Box>

      {showLoginModal && (
        <LoginModal onClose={() => setShowLoginModal(false)} />
      )}

      {/* FULL SCREEN IMAGE VIEW */}
      <Dialog
        open={openImageModal}
        onClose={() => setOpenImageModal(false)}
        maxWidth="lg"
        fullWidth
      >
        <Box sx={{ position: "relative", bgcolor: "black" }}>
          {/* CLOSE BUTTON */}
          <IconButton
            onClick={() => setOpenImageModal(false)}
            sx={{
              position: "absolute",
              top: 10,
              right: 10,
              color: "white",
              zIndex: 10,
            }}
          >
            <CloseIcon />
          </IconButton>

          {/* LEFT ARROW */}
          {images.length > 1 && (
            <IconButton
              onClick={() =>
                setCurrentImg((prev) =>
                  prev === 0 ? images.length - 1 : prev - 1
                )
              }
              sx={{
                position: "absolute",
                top: "50%",
                left: 10,
                transform: "translateY(-50%)",
                color: "white",
              }}
            >
              <KeyboardArrowUpIcon sx={{ transform: "rotate(-90deg)", fontSize: 40 }} />
            </IconButton>
          )}

          {/* IMAGE */}
          <Box
            component="img"
            src={images[currentImg]}
            sx={{
              width: "100%",
              height: "80vh",
              objectFit: "contain",
            }}
          />

          {/* RIGHT ARROW */}
          {images.length > 1 && (
            <IconButton
              onClick={() =>
                setCurrentImg((prev) =>
                  prev === images.length - 1 ? 0 : prev + 1
                )
              }
              sx={{
                position: "absolute",
                top: "50%",
                right: 10,
                transform: "translateY(-50%)",
                color: "white",
              }}
            >
              <KeyboardArrowDownIcon sx={{ transform: "rotate(-90deg)", fontSize: 40 }} />
            </IconButton>
          )}
        </Box>
      </Dialog>

      {openEnquiryModal && (
        <EnquiryModal
          open={openEnquiryModal}
          onClose={() => setOpenEnquiryModal(false)}
          propertyData={data?.apartment?.Id}
          type={data?.apartment?.PropertyType}
          selectedFlat={selectedFlat?.Id}
        />
      )}
      {showContactModal && (
        <ContactModal
          open={showContactModal}
          onClose={() => setShowContactModal(false)}
          property={{
            FlatName: selectedFlat?.FlatName,
            Floor: selectedFlat?.FloorNo,
            Type: selectedFlat?.FlatType,
          }}
        />
      )}

      <Snackbar
        open={snackbar.open}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        onClose={() => setSnackbar({ ...snackbar, open: false })}
      >
        <Alert
          severity={snackbar.severity}
          onClose={() => setSnackbar({ ...snackbar, open: false })}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {snackbar.message}
        </Alert>
      </Snackbar>




    </>
  );
};

export default AprtmentPlotsDetails;


const statusStyles = {
  approved: {
    bg: "#D0F0C0",        // green
    border: "#2E7D32",
    cursor: "pointer",
  },
  pending: {
    bg: "#FFF3CD",        // yellow
    border: "#FFC107",
    cursor: "not-allowed",
  },
  "in progress": {
    bg: "#E3F2FD",        // blue
    border: "#1976D2",
    cursor: "not-allowed",
  },
  "sale initiated": {
    bg: "#E0E0E0",        // gray
    border: "#616161",
    cursor: "not-allowed",
  },
  rejected: {
    bg: "#FFCDD2",        // red
    border: "#D32F2F",
    cursor: "not-allowed",
  },
};
